import $x from '@/utils/$x';

/**
 * iDong AI 课运营 - 计划列表
 * planScope: 'COPY'（默认，副本计划，运营页列表）/ 'SOURCE'（Apollo 配置的可复制源计划）
 */
export const listAiPlans = ({
  planScope = 'COPY',
  instrumentType,
  planName,
} = {}) => {
  return $x.post('/idong/plan-course/plans', {
    requestData: { planScope, instrumentType, planName },
  });
};

// 计划内课程列表（含未推送课程与推送状态）
export const listPlanCourses = (planId) => {
  return $x.post('/idong/plan-course/courses', { requestData: { planId } });
};

// 复制计划（含课程副本）
export const copyPlan = ({
  requestId,
  sourcePlanId,
  newPlanName,
  courseNameSuffix,
  instrumentType,
}) => {
  return $x.post('/idong/plan-copy/copy', {
    requestData: {
      requestId,
      sourcePlanId,
      newPlanName,
      courseNameSuffix,
      instrumentType,
    },
  });
};

// 课程改名（单条/批量共用，items: [{courseType, courseIdent, courseName}]）
export const renamePlanCourses = ({ requestId, planId, items }) => {
  return $x.post('/idong/plan-copy/rename', {
    requestData: { requestId, planId, items },
  });
};

// 触发推送：syncPlanIdList（计划级）/ syncCourseList（单课程，格式 courseType_courseIdent）
export const pushAiCourses = ({
  syncPlanIdList,
  syncCourseList,
  planId,
  planCourseType,
  trialCourseList,
} = {}) => {
  return $x.post('/idong/plan-course/push', {
    requestData: {
      syncPlanIdList,
      syncCourseList,
      // AI 课按课程推送时必须带 planId：器械/目标/难度/卡路里都靠计划上下文推导
      planId,
      planCourseType,
      trialCourseList,
    },
  });
};

// 已推送记录分页（沿用既有接口）
export const pageIdongPlanCourses = (params) => {
  return $x.post('/idong/plan-course/page', params);
};

// 重新推送
export const repushAiCourses = (requestId, courseIds) => {
  return $x.post('/idong/plan-course/repush', {
    requestData: { requestId, courseIds },
  });
};

export { genRequestId } from './recordCourse';

// 读取课程完整结构（阶段 + 动作 + actionPlanId）
export const getCourseStructure = ({ courseType, courseIdent }) => {
  return $x.post('/idong/plan-course/course-structure', {
    requestData: { courseType, courseIdent },
  });
};

// 保存课程完整结构（editCourseV2：课程名 + 阶段 + 动作整体提交）
export const saveCourseStructure = (requestData) => {
  return $x.post('/idong/plan-course/course-structure/save', { requestData });
};

// 修改副本计划信息（计划名称/介绍/器械档位）
export const updatePlanInfo = ({
  planId,
  planName,
  planIntro,
  instrumentType,
}) => {
  return $x.post('/idong/plan-copy/plan-info', {
    requestData: { planId, planName, planIntro, instrumentType },
  });
};
